async function waitForImages(doc: Document): Promise<void> {
  const images = Array.from(doc.images).filter((image) => !image.complete);

  if (!images.length) {
    return;
  }

  await Promise.all(
    images.map(
      (image) =>
        new Promise<void>((resolve) => {
          image.addEventListener("load", () => resolve(), { once: true });
          image.addEventListener("error", () => resolve(), { once: true });
        })
    )
  );
}

async function waitForFonts(doc: Document): Promise<void> {
  const fontSet = doc.fonts;

  if (!fontSet || typeof fontSet.ready === "undefined") {
    return;
  }

  await fontSet.ready;
}

// Delay measurement and print until asynchronous visual assets settle. This is
// especially important for estimated pagination and barcode/QR-heavy layouts.
export async function waitForAssets(doc: Document): Promise<void> {
  await Promise.all([waitForImages(doc), waitForFonts(doc)]);
}
